import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { RootState } from 'stores';
import { TProduct, ProductManagementContext } from 'modules/ProductManagement/reducers/type';
import { getProductManagementContext } from '../../reducers/accessors';
import { trackClickEventInProductManagement } from 'modules/ProductManagement/helper';
import { EButtonNames, EActionType } from 'modules/ProductManagement/type';
import { ERoutePath } from 'router';
import { useHistory } from 'react-router-dom';
import { CancellationWrapper } from 'modules/ProductManagement/style';
import { getFirstElementInProductList } from '../../reducers/accessors';
import { Button } from '@myob/myob-widgets';

export type ProductCancellationState = {
    serialNumber: string;
    productName: string;
};

const Cancellation: React.FC = () => {
    const history = useHistory<ProductCancellationState>();
    const { productType, serialNumber, actions } = useSelector<RootState, TProduct>(getFirstElementInProductList);
    const productManagementContext = useSelector<RootState, ProductManagementContext>(
        getProductManagementContext,
        shallowEqual,
    );
    const handleCancellationClick = () => {
        trackClickEventInProductManagement(productManagementContext, EButtonNames.RequestCancellation);
        history.push({
            pathname: ERoutePath.RequestCancellation,
            state: {
                serialNumber: serialNumber,
                productName: productType,
            },
        });
    };
    const cancellationAction = actions?.find(action => action.id === EActionType.REQUEST_CANCELLATION);

    return (
        <CancellationWrapper>
            {cancellationAction && (
                <Button type="link" onClick={handleCancellationClick}>
                    Request cancellation
                </Button>
            )}
        </CancellationWrapper>
    );
};

export default Cancellation;
